import React from 'react'
import Lottie from 'lottie-react'

interface LottieViewProps {
  source: unknown
  autoPlay?: boolean
  loop?: boolean
  style?: React.CSSProperties
}

export const LottieView: React.FC<LottieViewProps> = ({
  source,
  autoPlay = true,
  loop = true,
  style,
}) => {
  return (
    <Lottie
      animationData={source}
      loop={loop}
      autoplay={autoPlay}
      style={style}
    />
  )
}
